import React, { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';

export function HandleMiddlewareError(result): ReactElement {
  const location = useLocation();
  const values = queryString.parse(location.search);

  if (typeof result === 'function') {
    return result();
  }

  if (typeof result === 'string') {
    return (
      <Navigate
        to={result + `${location.search}`}
        state={{ from: values }} // <-- pass in route state
        replace
      />
    );
  }

  return null;
}
